/**
 *
 * ProfileAmbassador
 *
 */

import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { Link } from "react-router-dom"

import Layout from "components/Layout"
import ModalActionPlanCreate from "components/ModalActionPlanCreate"
import ModalCustom from "components/ModalCustom"
import ActionPlanCard from "components/ActionPlanCard"
import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import iconPhone from "images/icon_phone.svg"
import iconTicket from "images/ticket.svg"
import iconMessage from "images/icon_message.svg"
import iconBirthday from "images/icon_birthday.svg"
import iconBarHorizontal from "images/icon_bars_horizontal.svg"
import emptyStateActionPlans from "images/empty-state-action-plans.svg"
import alertSvg from "images/alert.svg"
import { Select, Button, Pagination, Empty, Spin, Popover } from "antd"
import { saveActionPlanApi } from "services/actionPlans"
import UserImage from "components/UserImage"
import UserList from "components/UserList"
import { ROLE_LEADER, ACTION_PLANS } from "utils/constants"
import saga from "./saga"
import { getPlansWatcher, updatePhotoWatcher } from "./actions"
import {
  makeSelectLoadingPlans,
  makeSelectPlans,
  makeSelectAmbassador,
  makeSelectDivisions,
  makeSelectFilter,
  makeSelectCountActionPlans,
  makeSelectLoadingPhoto,
  makeSelectLeaderTeam,
  makeSelectCurrentUserCanAction,
} from "./selectors"
import reducer from "./reducer"
import "./index.less"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import { isModuleBySlug, LOCAL_ACTIVE_ROL } from "../../utils/storage"
import { loadTexts, sanitize } from "../../utils/i18n"
import moment from "moment"
/* eslint-disable react/prefer-stateless-function */
export class ProfileAmbassador extends React.Component {
  intlProfileAmbassador = loadTexts("my_profile").profileAmbassador
  id = parseInt(this.props.match.params.id)
  state = {
    paginationCurrentPage: 1,
    paginationPageSize: 15,
    modalActionPlanCreate: false,
    modalActionPlanEditId: null,
    selectedOrder: null,
    canCreate: false,
    isFilter: false,
    modalArchivePlan: false,
    modalArchiveLoading: false,
    currentPlan: {},
    measuresModalCreate: [],
  }

  componentDidMount() {
    this.getPlans()
  }

  componentDidUpdate = (nextProps) => {
    // Siempre cuando el plans_loading cambie, se reinicia el paginador
    if (nextProps.plans_loading !== this.props.plans_loading) {
      this.onChange(1)
    }
  }

  getPlans = () => {
    this.props.getPlans({
      id_ambassador: this.id,
      type_active_plan: this.state.selectedOrder,
    })
  }

  onShowSizeChange = (current, pageSize) => {
    this.setState({ paginationPageSize: pageSize }, () => {
      this.onChange(1)
    })
  }

  onChange = (page) => {
    const { plans } = this.props
    const { paginationPageSize } = this.state
    this.setState({ paginationCurrentPage: page }, () => {
      const startIndex = (page - 1) * paginationPageSize
      const endIndex = Math.min(
        startIndex + paginationPageSize - 1,
        plans.length - 1
      )
      const rows = plans.slice(startIndex, endIndex + 1)
      this.setState({ rows })
    })
  }

  render() {
    const {
      plans_loading,
      plans,
      filter,
      divisions,
      ambassador,
      count_action_plans,
      leader_team,
      current_user_can_action,
    } = this.props
    const {
      paginationCurrentPage,
      modalActionPlanCreate,
      modalActionPlanEditId,
      rows,
      canCreate,
      isFilter,
      modalArchivePlan,
      currentPlan,
      modalArchiveLoading,
      measuresModalCreate,
    } = this.state

    const isUserLeader = LOCAL_ACTIVE_ROL() === ROLE_LEADER.toString()

    if (ambassador.id_ambassador !== this.id) {
      return (
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      )
    }
    const isActionPlans = isModuleBySlug(ACTION_PLANS)
    return (
      <Layout>
        <Helmet>
          <title>{this.intlProfileAmbassador.titlePage}</title>
          <meta name="description" content="Description of Ambassador" />
        </Helmet>
        <div className="ProfileAmbassador" style={{ marginBottom: 60 }}>
          <div className="ProfileAmbassador-left">
            {queryString(this.props.location.search).rd == "organization" && (
              <Link
                to="/organization#collaborators"
                style={{ marginTop: "-20px", width: 60 }}>
                &lt; Perfil
              </Link>
            )}

            <div className="ProfileAmbassador-left-header">
              <div className="ProfileAmbassador-left-header-avatar">
                {/* <Avatar size={174} src={ambassador.profile_picture} /> */}
                <Spin spinning={this.props.loading_photo} size="large">
                  <UserImage
                    isAmbassador
                    url={ambassador.profile_picture}
                    setFile={(f) => {
                      const fd = new FormData()
                      fd.append("id", this.props.ambassador.id_ambassador)
                      if (f) {
                        fd.append("uploaded_file", f)
                      }
                      fd.append("delete_photo", !f)
                      this.props.updatePhoto(fd)
                    }}
                  />
                </Spin>
              </div>
              <div className="ProfileAmbassador-left-header-separator" />
              <div className="ProfileAmbassador-left-header-content">
                <div className="ProfileAmbassador-left-header-content-title">
                  <div className="string_dots">
                    <b>
                      {`${ambassador.first_name || ""} ${ambassador.last_name ||
                        ""}`}{" "}
                    </b>{" "}
                    -{" "}
                    <span
                      className="color-gray-low"
                      style={{ fontWeight: "normal" }}>
                      {" "}
                      {ambassador.name_position || ""}
                    </span>
                  </div>
                  <span
                    style={{
                      marginLeft: "auto",
                      fontWeight: 600,
                      paddingLeft: 15,
                    }}
                    className="string_dots">
                    <img
                      src={iconTicket}
                      style={{ marginRight: 5 }}
                      alt="icon-ticket"
                    />
                    {Array.isArray(divisions) &&
                      divisions.map((d, dI) => {
                        const division_name =
                          d.name + (dI + 1 == divisions.length ? "" : ", ")
                        return d.allow ? (
                          <Popover
                            placement="bottom"
                            key={`popover-division-ambassador-${dI}`}
                            content={
                              <div style={{ maxWidth: 230 }}>
                                {sanitize(
                                  this.intlProfileAmbassador.popover
                                    .ambassadorEngagement
                                )}
                                <br />
                                <span
                                  style={{
                                    fontSize: 11,
                                    paddingTop: 5,
                                    display: "block",
                                  }}>
                                  {sanitize(
                                    this.intlProfileAmbassador.popover
                                      .clickDivisionToSeeResults
                                  )}
                                </span>
                              </div>
                            }>
                            <Link
                              to={`/reports/measure/${d.id_measure}/divisions/${d.id_division}/dimensions?rd=ambassador&rd_id=${this.id}`}
                              style={{ color: "#4F4F4F" }}>
                              {division_name}
                            </Link>
                          </Popover>
                        ) : (
                          division_name
                        )
                      })}
                  </span>
                </div>
                <div className="ProfileAmbassador-left-header-content-variables">
                  <div className="string_dots">
                    <img src={iconPhone} />
                    {ambassador.phone || "-"}
                  </div>
                  <div className="string_dots">
                    <b>{this.intlProfileAmbassador.timeInCompany}</b>{" "}
                    {ambassador.date_admission_2 || "-"}
                  </div>
                  <div className="string_dots">
                    <img src={iconMessage} />
                    {ambassador.email || "-"}
                  </div>
                  <div className="string_dots">
                    <img src={iconBirthday} />
                    {moment(ambassador.date_birth).locale('es').format('D [de] MMMM') || "-"}
                  </div>
                </div>
                {isActionPlans && (
                  <div className="ProfileAmbassador-left-header-content-tabs">
                    <div className="ProfileAmbassador-left-header-content-tabs-selected">
                      <img src={iconBarHorizontal} />
                      {` ${this.intlProfileAmbassador.actionPlans}`}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {isActionPlans && (
              <div className="ProfileAmbassador-left-content">
                {plans_loading && !isFilter ? (
                  <div className="loadingSpin">
                    <Spin size="large" />
                  </div>
                ) : count_action_plans === 0 && !isFilter ? (
                  <div className="ActionPlans-Empty">
                    <Empty
                      style={{ color: "#828282" }}
                      image={emptyStateActionPlans}
                      description={
                        <Fragment>
                          <span
                            style={{ margin: "20px auto", display: "block" }}>
                            {sanitize(
                              this.intlProfileAmbassador.emptyActionPlans.header
                            )}
                          </span>
                          <span className="ActionPlans-Empty-dashed">
                            {sanitize(
                              this.intlProfileAmbassador.emptyActionPlans.body
                            )}
                          </span>
                          <br />
                          <br />
                          {!isUserLeader &&
                            validRole({ role: [1, 2, 3, 4, 5] }) &&
                            current_user_can_action &&
                            canCreate && (
                              <Button
                                className="btn-orange"
                                onClick={() => {
                                  woopraTrack("Crear plan de acción")
                                  this.setState({ modalActionPlanCreate: true })
                                }}>
                                {
                                  this.intlProfileAmbassador.emptyActionPlans
                                    .btnCreateActionPlan
                                } 
                              </Button>
                            )}
                        </Fragment>
                      }
                    />
                  </div>
                ) : (
                  <Fragment>
                    <div className="ProfileAmbassador-left-content-header">
                      <div>
                        <span className="title_section">
                          {this.intlProfileAmbassador.actionPlans} (
                          {plans.length || 0})
                        </span>
                        <Select
                          placeholder={this.intlProfileAmbassador.orderBy}
                          defaultValue={null}
                          onChange={(e) =>
                            this.setState(
                              { selectedOrder: e, isFilter: true },
                              () => this.getPlans()
                            )
                          }
                          style={{ width: 180, marginLeft: 15 }}>
                          {Array.isArray(filter) &&
                            filter.map((e) => (
                              <Select.Option
                                key={`filter-${e.id}`}
                                value={e.id}>
                                {e.name}
                              </Select.Option>
                            ))}
                        </Select>
                      </div>
                      {!isUserLeader &&
                        current_user_can_action &&
                        canCreate &&
                        validRole({ role: [1, 2, 3, 4, 5] }) && (
                          <Button
                            style={{ marginLeft: "auto" }}
                            type="primary"
                            onClick={() => {
                              woopraTrack("Crear plan de acción")
                              this.setState({ modalActionPlanCreate: true })
                            }}>
                            {this.intlProfileAmbassador.btnCreateActionPlan}
                          </Button>
                        )}
                    </div>
                    <div style={{ display: "grid", gridGap: 7 }}>
                      {plans_loading ? (
                        <div className="loadingSpin">
                          <Spin size="large" />
                        </div>
                      ) : Array.isArray(rows) && rows.length > 0 ? (
                        <Fragment>
                          {rows.map((p, pi) => (
                            <ActionPlanCard
                              canCreateTask
                              canOpen
                              canEdit={p.editable}
                              item={p}
                              key={`action-plan-${p.id_action_plan}`}
                              onEdit={(e) => {
                                this.setState({
                                  modalActionPlanCreate: true,
                                  modalActionPlanEditId: p.id_action_plan,
                                })
                              }}
                              onArchive={(e) => {
                                this.setState({
                                  modalArchivePlan: true,
                                  currentPlan: p,
                                })
                              }}
                              onReloadActionPlan={(e) => {
                                rows[pi] = Object.assign(rows[pi], e)
                                this.setState({ rows })
                              }}
                            />
                          ))}
                          {!plans_loading && (
                            <Pagination
                              showSizeChanger
                              defaultPageSize={15}
                              pageSizeOptions={["15", "25", "50", "100"]}
                              onShowSizeChange={this.onShowSizeChange}
                              onChange={this.onChange}
                              defaultCurrent={paginationCurrentPage}
                              total={plans.length}
                            />
                          )}
                        </Fragment>
                      ) : (
                        <Empty
                          style={{ color: "#828282", marginTop: 60 }}
                          image={emptyStateActionPlans}
                          description={
                            <span
                              style={{ margin: "20px auto", display: "block" }}>
                              {" "}
                              {this.intlProfileAmbassador.notResultsFound}
                            </span>
                          }
                        />
                      )}
                    </div>
                  </Fragment>
                )}
              </div>
            )}
          </div>
          <div className="ProfileAmbassador-right">
            <UserList
              titleType="alt"
              listProps={{ bottomLine: false }}
              title={`${this.intlProfileAmbassador.userListTeam} (${leader_team.length})`}
              list={leader_team}
            />
          </div>
        </div>

        <ModalActionPlanCreate
          visible={modalActionPlanCreate}
          modalActionPlanEditId={modalActionPlanEditId}
          canCreate={(e) => this.setState({ canCreate: e })}
          onCancel={() =>
            this.setState({
              modalActionPlanCreate: false,
              modalActionPlanEditId: null,
            })
          }
          finish={() => {
            this.getPlans()
          }}
          initialData={{
            selectedAmbassador: { id_ambassador: this.id },
            measure:
              measuresModalCreate.length > 0
                ? measuresModalCreate[0].id_measure
                : null,
          }}
          setMeasures={(e) => this.setState({ measuresModalCreate: e })}
        />

        <ModalCustom
          modalOpen={modalArchivePlan}
          showFooter
          textButton="Archivar"
          onOk={async () => {
            this.setState({ modalArchiveLoading: true })
            try {
              const result = await saveActionPlanApi({
                id: currentPlan.id_action_plan,
                archived: 1,
              })
              this.setState({
                modalArchivePlan: false,
                modalArchiveLoading: false,
                currentPlan: {},
              })
              this.getPlans()
              returnMessage(result)
            } catch (error) {
              this.setState({
                modalArchivePlan: false,
                modalArchiveLoading: false,
              })
              returnMessage(error)
            }
          }}
          onCancel={() => {
            this.setState({ modalArchivePlan: false })
          }}
          isLoadingButton={modalArchiveLoading}>
          <div className="component-deletesimple">
            <img src={alertSvg} className="alertIcon" />
            <div className="component-deletesimple__description">
              <p>
                <b>¿Estás seguro de que deseas archivar el plan?</b>
              </p>
              <p>Este ya no aparecerá en tus planes de acción en curso.</p>
            </div>
          </div>
        </ModalCustom>
      </Layout>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  plans_loading: makeSelectLoadingPlans(),
  plans: makeSelectPlans(),
  ambassador: makeSelectAmbassador(),
  divisions: makeSelectDivisions(),
  filter: makeSelectFilter(),
  count_action_plans: makeSelectCountActionPlans(),
  loading_photo: makeSelectLoadingPhoto(),
  leader_team: makeSelectLeaderTeam(),
  current_user_can_action: makeSelectCurrentUserCanAction(),
})

function mapDispatchToProps(dispatch) {
  return {
    getPlans: (params) => dispatch(getPlansWatcher(params)),
    updatePhoto: (params) => dispatch(updatePhotoWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "profileAmbassador", reducer })
const withSaga = injectSaga({ key: "profileAmbassador", saga })

export default compose(withReducer, withSaga, withConnect)(ProfileAmbassador)
